import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, finalIncludedItems } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const noMore = ['No more hours searching for your next drill', 'No more disconnected training ideas', 'No more repeating the same session because planning time ran out', 'No more wondering what progression should come next', 'No more treating striking, clinch, takedowns and ground work as disconnected phases', 'No more starting every class from an empty page'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-violet-950 relative overflow-hidden" data-id="element-86" data-mp="vv1crr89uecc">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-87" data-mp="qvx5j64wqqon">
        <div className="text-center mb-16" data-id="element-88" data-mp="qwgmajitn913">
          <h2 className="text-3xl md:text-5xl font-black uppercase mb-8 leading-tight text-white" data-id="element-89" data-mp="14v6h1si64wma">
            Next week, you can keep building every session from scratch...
          </h2>
          <p className="text-xl md:text-2xl font-display font-extrabold text-violet-300 mb-10" data-id="element-90" data-mp="2c4ocezz2fd7s">
            Or you can open a complete 6-in-1 visual coaching system and already know where to
            start.
          </p>
          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/5 p-8 rounded-2xl border border-white/15" data-id="element-91" data-mp="2m2kts9ilj4ec">
            {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-92" data-mp="2qzkqvuxgwwtb">
                <span className="text-violet-300 mt-0.5" aria-hidden="true" data-id="element-93" data-mp="2v2zhtgmy2xlj">▸</span>
                <span className="text-white/80" data-id="element-94" data-mp="301ka8tvygczf">{item}</span>
              </div>)}
          </div>
          <p className="text-xl text-white mb-3" data-id="element-95" data-mp="34un6j9s4a0jb">
            MMA Coach Ready does not replace your knowledge as a coach.
          </p>
          <p className="text-lg md:text-xl font-display font-extrabold uppercase text-white/90" data-id="element-96" data-mp="39u9fh70wwumb">
            It gives you a system for using that knowledge with more structure, consistency and
            efficiency.
          </p>
        </div>

        <div className="bg-white border-2 border-violet-500 rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-97" data-mp="1jpelxizwhgvo">
          <h3 className="text-2xl font-black uppercase text-zinc-950 mb-6 text-center border-b border-zinc-200 pb-6" data-id="element-98" data-mp="1eq1qwayvl3i0">
            Everything included
          </h3>
          <ul className="grid sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-4 mb-10" data-id="element-99" data-mp="1npykmr04gsjx">
            {finalIncludedItems.map(item => <li key={item} className="flex items-start gap-3" data-id="element-100" data-mp="22drxw51qjizc">
                <Check size={18} className="text-green-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-101" data-mp="1xfqcvekr19l8" />
                <span className="text-sm text-zinc-700" data-id="element-102" data-mp="2bfj0h10zb9oz">{item}</span>
              </li>)}
          </ul>
          <div className="text-center" data-id="element-103" data-mp="27decahtav59q">
            <p className="text-xl font-display font-black text-zinc-950 mb-2" data-id="element-104" data-mp="27eflshuo3jpc">MMA COACH READY</p>
            <p className="text-sm text-zinc-500 mb-8 max-w-2xl mx-auto" data-id="element-105" data-mp="h209ka1gepcn">
              150 ready-to-coach MMA sessions designed to help coaches plan less, teach with more
              structure and develop athletes from beginner to advanced.
            </p>
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-106" data-mp="6y3328zk6ob9">
              Get the complete MMA coaching system now
            </Button>
            <div className="flex flex-wrap justify-center gap-4 text-xs text-zinc-500 mb-6" data-id="element-107" data-mp="3u8t15rnl9zi2">
              <span className="font-bold text-zinc-950" data-id="element-108" data-mp="3fc1wb2v5bvl2">$27 USD</span>
              <span data-id="element-109" data-mp="3kdivmtxzf9zj">• Immediate Access</span>
              <span data-id="element-110" data-mp="3kad9nnkngo81">• Complete 6-in-1 Digital Bundle</span>
            </div>
            <p className="text-lg font-display font-black uppercase text-zinc-950" data-id="element-111" data-mp="36e9i6215utz9">
              Stop building every session from scratch.
            </p>
            <p className="text-base text-zinc-600 mt-1" data-id="element-112" data-mp="14ksc32soi16m">
              Open the system. Choose the session. Start coaching.
            </p>
          </div>
        </div>
      </div>
    </section>;
}